import ChartOfAccounts from "./ChartOfAccounts";

const ChartOfAccountsConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/chart-of-accounts',
            element: <ChartOfAccounts />,
        },
    ],
}

export default ChartOfAccountsConfig;
